// import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency';
import { BehaviorSubject, Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { Injectable, inject } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
// import { UsercentricsCmp, UsercentricsConsents } from 'capacitor-plugin-usercentrics-cmp';

import { ConsentAppVendorSlug } from 'src/app/legal/consent/consent-vendors.config';
import { StorageService } from 'src/app/@core/storage.service';

@Injectable({
  providedIn: 'root',
})
export class ConsentService {
  private acceptedVendorSlugs:
  BehaviorSubject<ConsentAppVendorSlug[]> = new BehaviorSubject<ConsentAppVendorSlug[]>(null);

  private acceptedVendorSlugsStore: ConsentAppVendorSlug[] = [];
  private consentInProgress: boolean;
  private consentDeactivated = true;

  private loadingController = inject(LoadingController);
  private storage = inject(StorageService);
  private translate = inject(TranslateService);

  private static getAppTrackingTransparencyConsent(): boolean {
    // this should already be handled by AppTrackingTransparency plugin
    if (Capacitor.getPlatform() !== 'ios') {
      return true;
    }

    console.info('ConsentService#getAppTrackingTransparencyConsent');

    // const attResponse = await AppTrackingTransparency.getStatus();

    // if (attResponse.status === 'authorized') {
    //   return true;
    // }

    // if (attResponse.status === 'notDetermined') {
    //   const { status } = await AppTrackingTransparency.requestPermission();

    //   return status === 'authorized';
    // }

    return false;
  }

  // init consent + open native dialog view when user hasn't accepted consent yet
  public init(): Promise<void> {
    if (this.consentInProgress || this.consentDeactivated) {
      return Promise.resolve();
    }

    console.info('ConsentService#init');
    this.consentInProgress = true;

    const appTrackingTransparencyAllowed = ConsentService.getAppTrackingTransparencyConsent();

    this.storage.set('appTrackingTransparencyAllowed', appTrackingTransparencyAllowed);
    // await this.setAcceptedVendors('init');
    this.consentInProgress = false;

    return Promise.resolve();
  }

  public async update(): Promise<void> {
    if (this.consentInProgress) {
      return Promise.resolve();
    }

    console.info('ConsentService#update');
    this.consentInProgress = true;

    const loadingController = await this.loadingController.create({
      message: this.translate.instant('VIEW.COMMON.LOADING_MESSAGE.LOAD_CONSENT'),
    });

    // await this.setAcceptedVendors('update');
    await loadingController.dismiss();

    this.consentInProgress = false;

    return Promise.resolve();
  }

  public reset(): Promise<void> {
    if (this.consentInProgress) {
      return Promise.resolve();
    }

    console.info('ConsentService#reset');
    this.consentInProgress = true;
    // await this.setAcceptedVendors('reset');

    this.consentInProgress = false;

    return Promise.resolve();
  }

  public getAcceptedVendorSlugs(): Observable<ConsentAppVendorSlug[]> {
    return this.acceptedVendorSlugs.asObservable();
  }

  // private async setAcceptedVendors(mode: 'init' | 'update' | 'reset'): Promise<void> {
  //   let consentData: UsercentricsConsents;

  //   if (!usercentricsConfig) {
  //     console.error('usercentrics config not found. Check your environment.*.ts.');

  //     return Promise.resolve();
  //   }

  //   const language = this.languageService.getLanguage();

  //   try {
  //     // eslint-disable-next-line default-case
  //     switch (mode) {
  //       case 'init':
  //         consentData = await UsercentricsCmp.init({
  //           language,
  //           settingsId: usercentricsConfig.settingsId,
  //         });
  //         break;

  //       case 'update':
  //         consentData = await UsercentricsCmp.update({
  //           language,
  //         });
  //         break;

  //       case 'reset':
  //         consentData = await UsercentricsCmp.reset();
  //         break;
  //     }
  //   } catch (error) {
  //     console.error(error.message);
  //   }

  //   if (!consentData) {
  //     return Promise.resolve();
  //   }

  //   return this.onConsentReceived(consentData);
  // }

  // private onConsentReceived(data: UsercentricsConsents): Promise<void> {
  //   console.info('ConsentService#onConsentreceived', data);

  //   if (!data) {
  //     console.error('no consent data received');

  //     return Promise.resolve();
  //   }

  //   console.info('usercentrics consent response:', data.vendors);

  //   // map acceptedVendors to vendor slugs
  //   this.acceptedVendorSlugsStore = data.vendors
  //     .filter((vendor) => { return vendor.status; })
  //     .map((vendor) => { return CONSENT_APP_VENDOR_MAPPING[vendor.id]; });

  //   this.acceptedVendorSlugs.next(this.acceptedVendorSlugsStore);

  //   return Promise.resolve();
  // }
}
